/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { blockUi, unBlockUi } from '../../../../actions/actionCreator';
// utils
import {
  Translations,
  convertStringToArrayForOption,
  convertStringToArrayForRadio,
  loadIfStateAvailableInSessionStorage,
  safeGet
} from '../../../../utils';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../restClient';
// children
import Banner from '../../../common/Banner';
import Checkbox from '../../../common/Checkbox';
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
import MultiLineSelect from '../../../common/MultiLineSelect';
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';
import OptionalTextBox from '../../../common/OptionalTextBox/';
import PersistLink from '../../../common/PersistLink';
import Radiobutton from '../../../common/Radio/radioButton';
import SimpleDropdown from '../../../common/SimpleDropdown';
import { SweepSelectionsDialog } from './Modals';
import OrderableSweepList from './OrderableSweepList';
import SweepInstructionsList from './SweepInstructionsList';

//action Creator
import { hideActionButton } from '../../../layouts/actions/actionCreator';
import { setCurrentProductGlsCashCon, setCurrentProductGlsCashConStatuses } from '../../actions/actionCreator';

//style
import classNames from 'classnames';
import './styles.css';

class CaptureProductGlsCashCon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentGlsCashCon: {},
      sweepInstructions: [],
      accountInterestLimits: [],
      currentPage: 1,
      itemsPerPage: 10,
      loading: false,
      availableAccountsList: [],
      sweepGroupsLimits: [],
      reportedEChannelId: '',
      eChannelReported: false,
      noOfReporting: 1,
      noOfSweepGroups: 1,
      showSelectSweepInstructionsDialog: false,
      sweepInstructionsFilteredByCurrency: [],
      currentSelectedGroupIndex: undefined,
      orderOfExecution: [],
      isSweepOrderDefined: undefined,
      showDynamicSweepWarning: true,
      currencyList: [],
      bannersVisibility: {},
      cachedResourceData: {},
      start: 0,
      end: 50,
    };
    this.reportingEchannelDisableList = [];
    this.delteedSweepId = '';
    this.isSweepDeleted = false;
    this.taxanomyURL = '/product/taxonomies/sweepType';
  }


  handleLoadMore = () => {
    this.setState((prevState) => ({
      currentPage: prevState.currentPage + 1,
    }))
  }

  loadMore = () => {
    this.setState({ loading: true })
    this.handleLoadMore()
    setTimeout(() => {
      this.handleLoadMore()
      this.setState({ loading: false })
    }, 1000)
  }



  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }
  translateWordForOption = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  loadCaptureProductGlsCashConPageState = () => {
    var { productId } = this.props.match.params;
    let loadProduct;
    if (this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate === true) {
      loadProduct = `/product/gls/${productId}`
    } else {
      loadProduct = `/product/gls/${productId}`
    }

    eapiClient(loadProduct)
      .then(({ data }) => {
        if (data.responseData) {
          data.responseData.productId = productId;
          var _accountInterestLimits = [];
          var { sweepInstructions, accountInterestLimits, sweepGroupsLimits, orderOfExecution, eChannelReported, reportedEChannelId, isSweepOrderDefined } = data.responseData.cashConcentration;
          if (sweepInstructions !== undefined) {

            var defineSweepGroups = this.state.defineSweepGroups ? true : data.responseData.cashConcentration.sweepGroups === undefined ? false : data.responseData.cashConcentration.sweepGroups;
            if (this.state.sweepGroupsLimits.length > 0) {
              this.state.sweepGroupsLimits.map((sg, index) => {
                if (sg.sweepInstructions.length > 0) {
                  var index = sg.sweepInstructions.indexOf(this.delteedSweepId)
                  if (index > -1) {
                    sg.sweepInstructions.splice(index, 1);
                  }
                }
              })
              sweepGroupsLimits = this.state.sweepGroupsLimits;
            }

            var noOfSweepGroups = (sweepGroupsLimits !== undefined && sweepGroupsLimits.length > 0) ? sweepGroupsLimits.length : 1;
            accountInterestLimits.map((limitData, index) => {
              sweepInstructions.filter((sweepInstructionsData, id) => {
                if (sweepInstructionsData.sweepParticipantsAccounts !== undefined) {
                  if (sweepInstructionsData.sweepParticipantsAccounts.masterAccount === limitData.accountId || sweepInstructionsData.sweepParticipantsAccounts.subAccount === limitData.accountId) {
                    _accountInterestLimits.push(limitData);
                  }
                }
              })
            })

            var accountInterestLimitsFilter = _accountInterestLimits.reduce((acc, current) => {
              const x = acc.find(item => item.id === current.id);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            }, []);

            if (isSweepOrderDefined === undefined) {
              isSweepOrderDefined = undefined
            }
            this.setState({
              sweepInstructions: sweepInstructions || [],
              accountInterestLimits: accountInterestLimitsFilter || [],
              defineSweepGroups,
              sweepGroupsLimits: sweepGroupsLimits || [],
              orderOfExecution: orderOfExecution || [],
              isSweepOrderDefined: isSweepOrderDefined,
              noOfSweepGroups,
              eChannelReported: Boolean(eChannelReported),
              reportedEChannelId: reportedEChannelId,
              currentGlsCashCon: data.responseData
            }, () => {
              if (this.isSweepDeleted === true) {
                this.updateSweepAfterDelete();
              }
            });
            // setting data in redux
            this.props.setCurrentProductGlsCashCon({ ...data.responseData });
          }
        }
      });
  }

  componentWillMount() {
    var { caseId, productId } = this.props.match.params;
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadCaptureProductGlsCashConPageState();
    });



    eapiClient(`/product/gls/${productId}/case/${caseId}/account`)
      .then(({ data }) => {
        this.setState({ availableAccountsList: data.responseData });
      });

    taxonomyHostClient("/product/taxonomies/urn:hsbc:cmb:gdocs:products:taxonomies:AllCurrency")
      .then(({ data }) => {
        this.setState({ currencyList: data.responseData.classificationNodes });
      });

    this.loadCashConTabStatus();

    aemHostClient("/aemData/formData/json_cashcon-all-closed")
      .then(async ({ data }) => {
        this.setState({ pageJson: data });
        taxonomyHostClient(this.translations(this.state.pageJson && this.state.pageJson.par.aemform_sweepInstructions.accountTaxonomy))
          .then(({ data }) => {
            this.setState({ countryAccountList: data.responseData.countryTaxonomy.classificationNodes })

            taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_sweepInstructions.glsCashConTaxonomy))
              .then(({ data }) => {
                this.setState({ sweepTypes: data.responseData.classificationNodes });

                eapiClient("/product/caseRelatedEchannel/case/" + caseId)
                  .then(({ data }) => {
                    this.setState({ eChannels: data.responseData });
                    this.getTaxanomyUrl();
                  });
              });
          });
        if (data && data.par && data.par.aemform_accountInterestLimits.formRef) {
          const formRef = data.par.aemform_accountInterestLimits.formRef;
          const url = FORM_REFS[formRef];
          const { data: accountLimitJson } = await aemHostClient(url)
          const { guidedropdownlist_productParticipatingIn, guidedropdownlist_settlementPeriod } = accountLimitJson && accountLimitJson.guideContainer.rootPanel.items
          if (guidedropdownlist_productParticipatingIn.apiUrl && guidedropdownlist_settlementPeriod.apiUrl) {
            const { data: productParticipatingIn } = await taxonomyHostClient(this.translations(guidedropdownlist_productParticipatingIn.apiUrl))
            const { data: settlementPeriod } = await taxonomyHostClient(this.translations(guidedropdownlist_settlementPeriod.apiUrl))
            this.setState({
              cachedResourceData: { dropdown_productParticipatingIn: productParticipatingIn, dropdown_settlementPeriod: settlementPeriod, formSchema: accountLimitJson }
            })
          }
        }
      });

    aemHostClient("/aemData/formData/json_sweep-instructions-panel")
      .then(({ data }) => {
        this.setState({ sweepGroupsPageJson: data });
      });
    aemHostClient("/aemData/formData/json_gls-sweep-groups-limits")
      .then(({ data }) => {
        this.setState({ sweepGroupsLimitsPageJson: data });
      });
    aemHostClient("/aemData/formData/json_order-of-sweep-execution")
      .then(({ data }) => {
        this.setState({ sweepExecutionPageJson: data });
      });
    aemHostClient("/aemData/formData/json_gls-sweep-participants-accounts-form")
      .then(({ data }) => {
        this.setState({ sweepAccountsPageJson: data });
      });

    this.setEchannelReporting();
  }

  componentDidMount() {
    this.props.hideActionButton();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getTaxanomyUrl();

      taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_sweepInstructions.accountTaxonomy))
        .then(({ data }) => {
          this.setState({ countryAccountList: data.responseData.countryTaxonomy.classificationNodes })
        });

      taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_sweepInstructions.glsCashConTaxonomy))
        .then(({ data }) => {
          this.setState({ sweepTypes: data.responseData.classificationNodes });
        });
    }

    let disableItem = this.state.reportedEChannelId
    this.reportingEchannelDisableList = disableItem
    this.setState({
      reportedEChannelId: this.state.reportedEChannelId,
      disabledeChannelReporting: disableItem
    });

    if (this.state.getCurrentDropDownGlsReports) {
      const newAccountInterestLimits = this.state.accountInterestLimits ? [...this.state.accountInterestLimits] : []
      const { name, accInterestLimitIndex, index, value } = this.state.getCurrentDropDownGlsReports || {}
      if (newAccountInterestLimits[accInterestLimitIndex]) {
        if (newAccountInterestLimits[accInterestLimitIndex][name]) {
          newAccountInterestLimits[accInterestLimitIndex][name][index] = value
        } else if (newAccountInterestLimits[accInterestLimitIndex]) {
          newAccountInterestLimits[accInterestLimitIndex][name] = []
          newAccountInterestLimits[accInterestLimitIndex][name][index] = value
        }
        this.setState({
          accountInterestLimits: newAccountInterestLimits
        }, () => {
          if (this.state.getCurrentDropDownGlsReports) {
            this.setState({
              getCurrentDropDownGlsReports: undefined
            })
          }
        })
      }
    }

  }

  setEchannelReporting = () => {
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);

    if (getCurrentDropDown && getCurrentDropDown.includes("glsReports") && getCurrentDropDownValue) {
      const [dropDownName, accInterestLimitIndex, dropDownIndex] = getCurrentDropDown.split("-")
      // const newAccountLimits = [...this.state.accountInterestLimits]
      // if (newAccountLimits[accInterestLimitIndex] && newAccountLimits[accInterestLimitIndex][dropDownName]) {
      //   newAccountLimits[accInterestLimitIndex][dropDownName][dropDownIndex] = getCurrentDropDownValue
      // }
      this.setState({
        getCurrentDropDownGlsReports: { name: dropDownName, index: dropDownIndex, accInterestLimitIndex: accInterestLimitIndex, value: getCurrentDropDownValue }
      })
    }

    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - 1);
    }

    if (getCurrentDropDownName === 'eChannelReporting' || getCurrentDropDownName === 'accountSignatories') {
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length - 1);
    }
    var _eChannelReporting = this.state.reportedEChannelId;

    if (getCurrentDropDownName === 'eChannelReporting' && getCurrentDropDownValue !== null) {
      _eChannelReporting = getCurrentDropDownValue;
      let disableItem = _eChannelReporting
      this.reportingEchannelDisableList = disableItem
      this.setState({
        reportedEChannelId: _eChannelReporting,
        disabledeChannelReporting: disableItem,
        eChannelReported: false
      });
    }
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
    window.sessionStorage.removeItem("getCurrentDropDown");
  }

  getTaxanomyUrl = () => {
    let eChannels = this.state.eChannels;
    taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_echannelReporting.countryTaxonomy))
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          let currentListCountries = data.responseData.classificationNodes;
          if (eChannels !== undefined) {
            eChannels = eChannels.map(item => {
              currentListCountries.filter(countItem => {
                if ('country' in item) {
                  if (countItem.id === item.country.value) {
                    item.country.name = countItem.name
                  }
                }
                return item;
              });

              this.setState([...eChannels]);
            });
          }
        }
      });
  }

  getBasicDetails = (basicDetails) => {
    this.setState({ basicDetails });
  }
  renderBasicDetailsForm() {
    var formData;
    if (this.state.currentGlsCashCon !== undefined && this.state.currentGlsCashCon.id !== undefined) {
      formData = { ...this.state.currentGlsCashCon };
    } else {
      formData = {};
    }
    const properties = {
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'gls-cashcon',
      pathname: this.props.history.location.pathname
    };
    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_basicDetails !== undefined) {
      var aemform = this.state.pageJson.par.aemform_basicDetails;
      var formRef = this.state.pageJson.par.aemform_basicDetails.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform mode="edit"
            properties={properties}
            flag="true"
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onBasicDetailTabDataSubmit}
            getFormData={this.getBasicDetails}
            history={this.props.history}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            resetDisable={true}
          />
        );
      }
    }
  }

  onBannerClose = (bannerId) => {
    this.setState({
      bannersVisibility: { ...this.state.bannersVisibility, [bannerId]: true }
    });
  }

  renderSweepInstructionsForm = () => {
    return (
      <div className="sweep-instructions-section">
        <Banner
          key="sweep-banner-1"
          bannerId="sweep-banner-1"
          bannerType="primary"
          actionCallback={this.onBannerClose}
          hide={this.state.bannersVisibility['ci-customer-banner']}
          actionText={this.translations(this.state.sweepGroupsPageJson.par.staticText_sweepInstructions.closeText)}
          notificationTxt2={this.translations(this.state.sweepGroupsPageJson.par && this.state.sweepGroupsPageJson.par.staticText_sweepInstructions &&
            this.state.sweepGroupsPageJson.par.staticText_sweepInstructions.notificationTxt2)}
        >
          {this.translations(this.state.sweepGroupsPageJson.par.staticText_sweepInstructions.notificationTxt)}
        </Banner>
        <SweepInstructionsList items={this.state.sweepInstructions || []}
          accounts={this.state.availableAccountsList || []}
          pageJson={this.state.sweepGroupsPageJson.par}
          _onClick={this.toSweepInstructionEditPage}
          accountList={this.state.countryAccountList}
          lang={this.props.lang}
          sweepTypes={this.state.sweepTypes}
          disabled={this.props.customer.roleDetails.customer}
          _onDelete={this.deleteSweepInstruction}
          copySweepFrom={true}
          handleCopySweepFrom={this.handleCopySweepFrom}
        />
        <button className="gdocs-btn-default" disabled={this.props.customer.roleDetails.customer} onClick={this.toSweepInstructionCreatePage}><i className="icon icon-add"></i>{this.translations(this.state.sweepGroupsPageJson.par.staticText_sweepInstructions.addSweepBtnText)}</button>
      </div>
    );
  }

  getAccountInterestLimitData = (index, accountInterestLimitData) => {
    var accountInterestLimits = [...this.state.accountInterestLimits];
    accountInterestLimits[index] = accountInterestLimitData;
    this.setState({ accountInterestLimits });
  }
  renderEachAccountInterestAndLimit = (accountInterestLimit, index) => {
    var formData = {};
    let lendingLimitBreachAction = {
      name: "N/A",
      value: "na"
    }
    let borrowingLimitBreachAction = {
      name: "N/A",
      value: "na"
    }

    if (accountInterestLimit !== undefined && accountInterestLimit.id !== undefined) {
      formData = { ...accountInterestLimit }
      if ("odLimit" in accountInterestLimit === false) {
        formData['odLimit'] = 'N/A';
      }
      if ("unauthorizedInterestType" in accountInterestLimit === false) {
        formData['unauthorizedInterestType'] = 'floating'
      }
      if ("lendingLimit" in accountInterestLimit === false) {
        formData['lendingLimit'] = 'N/A'
      }
      if ("borrowingLimit" in accountInterestLimit === false) {
        formData['borrowingLimit'] = 'N/A'
      }
      if ('lendingLimitBreachAction' in formData === false) {
        formData.lendingLimitBreachAction = lendingLimitBreachAction;
      } if ('borrowingLimitBreachAction' in formData === false) {
        formData.borrowingLimitBreachAction = borrowingLimitBreachAction;
      }
      if ('unauthorizedOD' in formData) {
        formData.unauthorizedOD.rate = formData.unauthorizedOD.rate ? formData.unauthorizedOD.rate : 'fixed';
      }
      else {
        formData.unauthorizedOD = { rate: 'fixed' };
      }

    } else {
      formData['odLimit'] = 'N/A';
      formData['borrowingLimit'] = 'N/A';
      formData['unauthorizedInterestType'] = 'floating'
      formData['lendingLimit'] = 'N/A'
      formData.lendingLimitBreachAction = lendingLimitBreachAction;
      formData.borrowingLimitBreachAction = borrowingLimitBreachAction;
      formData.unauthorizedOD.rate = 'fixed';

    }
    var account = this.state.availableAccountsList.find(account => account.id === accountInterestLimit.accountId);
    var formHeader = (
      <div className="form-header">
        <label className="form-header__label-1">
          {safeGet(account, "accountType") !== undefined && safeGet(account, "accountType.name") !== '' ? safeGet(account, "accountType.name") + ',' : ''}
          {safeGet(account, "accountNumber") !== undefined && safeGet(account, "accountNumber") !== '' ? safeGet(account, "accountNumber") + ',' : ''}
          {safeGet(account, "branchCode") !== undefined && safeGet(account, "branchCode") !== '' ? safeGet(account, "branchCode") + ',' : ''}
          {safeGet(account, "country.name") !== undefined && safeGet(account, "country.name") !== '' ? safeGet(account, "country.name") + ',' : ''}
          {safeGet(account, "currency.name") !== undefined ? safeGet(account, "currency.name") : ''}
        </label>
        <label className="form-header__label-2">
          {safeGet(account, "accountHolder.name") !== undefined ? safeGet(account, "accountHolder.name") : ''}
        </label>
        <label className="form-header__label-3">
          {safeGet(account, "hsbcBankName.name") !== undefined && safeGet(account, "hsbcBankName.name") !== '' ? safeGet(account, "hsbcBankName.name") + ',' : ''}
          {safeGet(account, "bankName") !== undefined && safeGet(account, "bankName") !== '' ? safeGet(account, "bankName") + ',' : ''}
          {safeGet(account, "accountTitle") !== undefined && safeGet(account, "accountTitle") !== '' ? safeGet(account, "accountTitle") : ''}
          {safeGet(account, "tempRefrenceId") !== undefined && safeGet(account, "tempRefrenceId") !== '' ? `(${safeGet(account, "tempRefrenceId")})` : ''}
        </label>
      </div>
    );
    const properties = {
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'gls-cashcon-aacount-interest-and-limits',
      pathname: this.props.history.location.pathname,
      accountInterestLimitIndex: index,
      accountNumber: safeGet(account, "accountNumber")
    };
    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_accountInterestLimits !== undefined) {
      var aemform = this.state.pageJson.par.aemform_accountInterestLimits;
      var formRef = this.state.pageJson.par.aemform_accountInterestLimits.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform mode="edit" key={accountInterestLimit.id}
            properties={properties}
            hideButtons={true}
            getFormData={this.getAccountInterestLimitData.bind(this, index)}
            history={this.props.history}
            fieldPrefix={accountInterestLimit.id}
            formHeader={formHeader}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            isRepeatingComponentWithSameResourceUrl={false}
            cachedResourceData={this.state.cachedResourceData}
            reportingEchannels={(this.state.eChannels && this.state.eChannels.length &&
              this.state.eChannels.filter(eChannel => eChannel.eChannelType && eChannel.eChannelType.name === "HSBCnet")) || []}
            isEchannelRestricted={true}
            requiredFields={{
              "row1": ["eChannelType", "country"],
              "row2": ["profileOwner"],
              "row3": ["eChannelId"]
            }}
            pageState={this.state}
            disabledList={this.state.accountInterestLimits && this.state.accountInterestLimits[index] &&
              this.state.accountInterestLimits[index]["glsReports"]}
            formatters={{
              "row1": [null, (data, fieldValue) => data.newEchannel ? `${fieldValue} (New)` : `${fieldValue} (Existing)`, null],
              "row2": [],
              "row3": []
            }}
            handleGlsReportingApplyToAll={(reportIndex, eChannelId) => {
              const newAccountLimits = [...this.state.accountInterestLimits]
              newAccountLimits.forEach(account => {
                if (reportIndex > -1 && account.glsReports) {
                  account.glsReports[reportIndex] = eChannelId
                }
              })
              this.setState({
                accountInterestLimits: newAccountLimits
              })
            }}
          />
        );
      }
    }
  }
  renderAccountInterestAndLimitsForm() {
    const { accountInterestLimits, currentPage, itemsPerPage, loading } = this.state
    const bannerJSON = this.state.cachedResourceData.formSchema && this.state.cachedResourceData.formSchema.guideContainer &&
      this.state.cachedResourceData.formSchema.guideContainer.rootPanel && this.state.cachedResourceData.formSchema.guideContainer.rootPanel.items &&
      this.state.cachedResourceData.formSchema.guideContainer.rootPanel.items.notification_accountInterestRateBanner || {}
    if (accountInterestLimits && accountInterestLimits.length > 0) {
      const itemToRender = accountInterestLimits.slice(0, currentPage * itemsPerPage)
      return (
        <React.Fragment>
          {this.renderNotificationBanner(bannerJSON)}
          {itemToRender.map(this.renderEachAccountInterestAndLimit)}
          {itemToRender.length < accountInterestLimits.length && (
            <div className='loadmore-section' id="loadmore" >
              <button className="gdocs-btn-submit" id="loadertext">
                {loading ?
                  <h5><strong>Loading More </strong> <span className="dots"></span></h5>
                  : <h5><strong>There are more accounts to complete</strong></h5>
                }
              </button>
              <div>
                <button className="gdocs-btn-submit" id="loadmore-btn"
                  disabled={loading} onClick={this.loadMore}
                >
                  {loading ? <div> Loading<span className="dots"></span></div> : 'Load more'}
                </button>
              </div>
            </div>
          )}
        </React.Fragment>
      )
    }
  }

  renderNotificationBanner = ({ name = '', label1 = '', label2 = '', label3 = '', subLabels = '[]' }) => {
    let listItems
    try {
      listItems = subLabels && JSON.parse(this.translations(subLabels))
    } catch (err) {
      console.log(err)
    }
    return (
      <article>
        <h5><strong>
          {this.translations(label1)}
        </strong></h5>
        <h5><strong>
          {this.translations(label2)}
        </strong></h5>
        <ul>
          {Array.isArray(listItems) && listItems.map((item, itemIndex) => {
            return <li key={name + "-sublabels-" + itemIndex}><h5><strong>{item}</strong></h5></li>
          })}
        </ul>
        <h5><strong>{this.translations(label3)}</strong></h5>
      </article>
    )
  }

  toggleDialog = () => {
    this.setState({ showSelectSweepInstructionsDialog: false });
  }
  addSweepGroup = (cb) => {
    return eapiClient('/product/gls/cahscon/createSweepGroup', { method: 'POST' });
  }
  onSweepGroupAddition = () => {
    this.addSweepGroup()
      .then(({ data }) => {
        this.setState(prevState => {
          return {
            sweepGroupsLimits: [...prevState.sweepGroupsLimits, new SweepGroup(data.responseData)],
            noOfSweepGroups: prevState.noOfSweepGroups + 1
          }
        });
      });
    // this.setState(prevState => {
    //   return {
    //     sweepGroupsLimits: [this.state.sweepGroupsLimits.concat[{icsLimit: false}]],
    //     noOfSweepGroups: prevState.noOfSweepGroups+1
    //   }
    // });
  }

  onSweepGroupDeletion = (index) => {
    let sweepGroupsLimits = [...this.state.sweepGroupsLimits];
    let orderOfExecution = [...this.state.orderOfExecution];
    let sweepInstructions = [...this.state.sweepInstructions];
    let filterOderofExec = orderOfExecution.filter(ooe => ooe.sweepGroupId !== sweepGroupsLimits[index].id &&
      ooe.sweepGroupId !== undefined);
    filterOderofExec.forEach((x) => { delete x.orderNumber });
    let _uniqueGroup = [];
    let sweepInstructionList = [];
    let sweepGPList = [];
    let uniqueSweepGp = [];
    sweepGroupsLimits.splice(index, 1);
    filterOderofExec.map(x => _uniqueGroup.filter(a => a.sweepGroupId === x.sweepGroupId).length > 0 ? null : _uniqueGroup.push(x))
    sweepGroupsLimits.filter(si => sweepGPList.push(...si.sweepInstructions));
    sweepInstructions.filter((item, index) => {
      if (sweepGroupsLimits.length > 0 && sweepGPList.length > 0) {
        for (var value of sweepGPList) {
          if (uniqueSweepGp.indexOf(value) === -1) {
            uniqueSweepGp.push(value);
          }
        }
        if (uniqueSweepGp.indexOf(item.id) === -1) {
          sweepInstructionList.push(item)
        }
      }
      else {
        sweepInstructionList.push(item)
      }
    });
    let instructions = sweepInstructionList.map((item) => {
      return {
        sweepId: item.id
      }
    });
    let orderList = [...instructions, ..._uniqueGroup];
    let finalList = orderList.map((list, i) => {
      return {
        orderNumber: i + 1,
        ...list
      }
    })
    this.setState(prevState => {
      return {
        sweepGroupsLimits,
        noOfSweepGroups: prevState.noOfSweepGroups - 1,
        orderOfExecution: finalList
      }
    });
  }

  handleDefineSweepGroupsChange = (value, name) => {
    var orderOfExecution = [...this.state.orderOfExecution];
    var sweepInstructions = [...this.state.sweepInstructions];
    if (value === false && this.state.defineSweepGroups === false) {

      // clearing sweepGroups and groups in order of execution when define sweep groups is false
      // filtering objects related to sweep instructions
      orderOfExecution.filter(ooe => ooe.sweepId !== undefined);
      this.setState({ sweepGroupsLimits: [], noOfSweepGroups: 1, orderOfExecution });
    } else if (value === false && this.state.defineSweepGroups === true) {
      let sweeps = sweepInstructions.map((obj, i) => {
        return {
          orderNumber: i + 1,
          sweepId: obj.id
        }
      });
      this.setState({ sweepGroupsLimits: [], noOfSweepGroups: 1, orderOfExecution: sweeps });
    }
    else if (value === true && this.state.sweepGroupsLimits.length === 0) {
      this.props.blockUi();
      this.addSweepGroup().then(({ data }) => {
        this.setState({ sweepGroupsLimits: [new SweepGroup(data.responseData)] });
        this.props.unBlockUi();
      });
    }
    this.setState({ defineSweepGroups: value });
  }
  handleSweepGroupsRadioChange = (index, value, name) => {
    var sweepGroupsLimits = [...this.state.sweepGroupsLimits];
    var sweepGroup = { ...sweepGroupsLimits[index] };
    sweepGroup[name.split("-").pop()] = value;
    sweepGroupsLimits[index] = sweepGroup;
    this.setState({ sweepGroupsLimits });
  }
  getFilteredInstructions = (sweepInstructions, masterSweepInstrcutions, currencyCode) => {
    var _filteredMSI = masterSweepInstrcutions.filter(msi => sweepInstructions.indexOf(msi.id) !== -1);
    return _filteredMSI.reduce((acc, fmsi) => {
      if (safeGet(fmsi, "sweepParticipantsAccounts.currency.value") === currencyCode) {
        acc.push(fmsi.id);
      }
      return acc;
    }, []);
  }
  handleSweepGroupsDropdownChange = (index, event) => {
    var sweepGroupsLimits = [...this.state.sweepGroupsLimits];
    var sweepGroup = { ...sweepGroupsLimits[index] };
    if (event.target.name === "currency") {
      // filtering sweep instructions based on currency selection.
      var currencyCode = event.target.value;
      sweepGroup.sweepInstructions = this.getFilteredInstructions(sweepGroup.sweepInstructions, this.state.sweepInstructions, currencyCode);
    }
    sweepGroup[event.target.name] = {
      name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
      value: event.target.value
    };
    sweepGroupsLimits[index] = sweepGroup;
    this.setState({ sweepGroupsLimits });
  }
  handleSweepGroupsInputChange = (index, value, name) => {

    var sweepGroupsLimits = [...this.state.sweepGroupsLimits];
    var sweepGroup = { ...sweepGroupsLimits[index] };
    sweepGroup[name] = value;
    sweepGroupsLimits[index] = sweepGroup;
    this.setState({ sweepGroupsLimits });
  }
  getsweepSelections = (sweepSelections) => {
    return sweepSelections.map(ss => this.state.sweepInstructions.find(si => si.id === ss));
  }
  onSelectSweepInstructionsClick = (currentSelectedGroupIndex) => {
    var sweepInstructionsFilteredByCurrency = [];
    if (this.state.sweepGroupsLimits[currentSelectedGroupIndex].icsLimit) {
      var currencyId = this.state.sweepGroupsLimits[currentSelectedGroupIndex].currency.value;
      sweepInstructionsFilteredByCurrency = this.state.sweepInstructions
        .filter(si => {
          return safeGet(si, "sweepParticipantsAccounts.currency.value") === currencyId
        });
    }
    this.setState({
      showSelectSweepInstructionsDialog: true,
      currentSelectedGroupIndex,
      sweepInstructionsFilteredByCurrency
    });
  }
  _onSetSweepGroupSelections = (index, selections) => {
    var sweepGroupsLimits = [...this.state.sweepGroupsLimits];
    var sweepGroup = { ...this.state.sweepGroupsLimits[index] };
    sweepGroup.sweepInstructions = selections;
    sweepGroupsLimits[index] = sweepGroup;
    let sweepInstructionsList = [];
    sweepGroupsLimits.forEach((grp, index) => {
      sweepInstructionsList.push(grp.sweepInstructions);
    });
    let sweepArray = [].concat.apply([], sweepInstructionsList);
    let orderExec = this.state.orderOfExecution.filter(x => !sweepArray.includes(x.sweepId) && x.sweepGroupId === undefined);
    orderExec.forEach((x) => { delete x.orderNumber });
    let instructionGroup = [];
    sweepGroupsLimits.forEach((sgl, i) => {
      instructionGroup.push({
        sweepGroupId: sgl.id,
        intraGroupOrder: sgl.sweepInstructions.map(((item, index) => {
          return {
            sweepInstructionId: item,
            orderNumber: index + 1
          }
        }))
      });
    });
    let execOrder = [...orderExec, ...instructionGroup];
    let order = execOrder.map((obj, index) => ({ orderNumber: index + 1, ...obj }));
    this.setState({
      sweepGroupsLimits,
      orderOfExecution: order
    }, () => { });
  }

  shouldDisableSweepInstructionsSelection = (i) => {
    if (this.state.sweepGroupsLimits[i] && this.state.sweepGroupsLimits[i].icsLimit) {
      return this.state.sweepGroupsLimits[i].currency === undefined;
    }
    return false;
  }
  getSweepInstructionForGroupFormation = () => {
    var index = this.state.currentSelectedGroupIndex;
    if (this.state.sweepGroupsLimits[index] && this.state.sweepGroupsLimits[index].icsLimit) {
      return this.state.sweepInstructionsFilteredByCurrency;
    } else {
      return this.state.sweepInstructions;
    }
  }
  renderSweepGroupsAndLimits() {
    var sweepGroupSlotsJsx = [];
    for (var i = 0; i < this.state.noOfSweepGroups; i++) {
      if (this.state.sweepGroupsLimits[i] !== undefined) {
        'limit' in this.state.sweepGroupsLimits[i]
          ? this.state.sweepGroupsLimits[i].limit
          : this.state.sweepGroupsLimits[i].limit = 'N/A'

        'limitBreachAction' in this.state.sweepGroupsLimits[i]
          ? this.state.sweepGroupsLimits[i].limitBreachAction
          : this.state.sweepGroupsLimits[i].limitBreachAction = {
            name: "N/A",
            value: "na"
          }
      }
      sweepGroupSlotsJsx.push(
        <div className="sweep-group-limit-slot" key={i}>
          <label className="sweep-group-limit-slot__label">GRP-00{i + 1}</label>
          {i > 0 && !this.props.customer.roleDetails.customer ?
            <i className="icon icon-bin delete" role="button" onClick={this.onSweepGroupDeletion.bind(this, i)}></i> : ''}
          <div className="form-row">
            <div className="form-column">
              <label className="form-column__label">{this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.setICSLimit)}</label>
            </div>
            <div className="form-column">
              <label className="radio-label">
                {this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.no)}
                <Radiobutton setInputvalue={this.handleSweepGroupsRadioChange.bind(this, i)}
                  name={`${i}-icsLimit`}
                  disabled={this.props.customer.roleDetails.customer}
                  _value={this.state.sweepGroupsLimits[i] ? this.state.sweepGroupsLimits[i].icsLimit : ''}
                  value="false" />
              </label>
              <label className="radio-label">
                {this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.yes)}
                <Radiobutton setInputvalue={this.handleSweepGroupsRadioChange.bind(this, i)}
                  name={`${i}-icsLimit`}
                  disabled={this.props.customer.roleDetails.customer}
                  _value={this.state.sweepGroupsLimits[i] ? this.state.sweepGroupsLimits[i].icsLimit : ''}
                  value="true" />
              </label>
            </div>
          </div>
          {
            (this.state.sweepGroupsLimits[i] ? this.state.sweepGroupsLimits[i].icsLimit : false) ? (
              <div>
                <div className="form-row">
                  <div className="form-column">
                    <label className="form-column__label">{this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.limitType)}</label>
                  </div>
                  <div className="form-column">
                    <label>{this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.grpFacilityLimit)}</label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-column">
                    <label className="form-column__label">{this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.currency)}</label>
                  </div>
                  <div className="form-column">
                    <SimpleDropdown name="currency"
                      options={this.state.currencyList || []}
                      optionTextSelector="name"
                      disabled={this.props.customer.roleDetails.customer}
                      value={this.state.sweepGroupsLimits[i] ? (this.state.sweepGroupsLimits[i].currency ? this.state.sweepGroupsLimits[i].currency.value : '') : ''}
                      _onChange={this.handleSweepGroupsDropdownChange.bind(this, i)}
                      width="178px" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-column">
                    <label className="form-column__label">{this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.limit)}</label>
                  </div>
                  <div className="form-column">
                    <OptionalTextBox
                      className="form-column__input"
                      name='limit'
                      disabled={this.props.customer.roleDetails.customer}
                      _value={this.state.sweepGroupsLimits[i] ? (this.state.sweepGroupsLimits[i].limit) : ''}
                      max="10"
                      fieldPrefix={i}
                      setInputvalue={this.handleSweepGroupsInputChange.bind(this, i)}
                    />
                  </div>
                </div>
                {
                  this.state.sweepGroupsLimits[i].limit !== 'N/A'
                    ? <div className="form-row">
                      <div className="form-column">
                        <label className="form-column__label">{this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.limitBreach)}</label>
                      </div>
                      <div className="form-column">
                        <SimpleDropdown
                          name="limitBreachAction"
                          options={this.translateWordForOption(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.limitBreachOptions) || []}
                          disabled={this.props.customer.roleDetails.customer}
                          value={
                            this.state.sweepGroupsLimits[i]
                              ? (this.state.sweepGroupsLimits[i].limitBreachAction
                                ? this.state.sweepGroupsLimits[i].limitBreachAction.value
                                : 'N/A')
                              : ''
                          }
                          _onChange={this.handleSweepGroupsDropdownChange.bind(this, i)}
                          mode="aem"
                        />
                      </div>
                    </div>
                    : ''
                }
              </div>
            ) : ''
          }
          <hr className="sweep-group-limit-slot__hr"></hr>
          <label className="sweep-group-limit-slot__label">{this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.sweepInstructions)}</label>
          <SweepInstructionsList items={this.getsweepSelections(this.state.sweepGroupsLimits[i] ? (this.state.sweepGroupsLimits[i].sweepInstructions ? this.state.sweepGroupsLimits[i].sweepInstructions : []) : [])}
            accounts={this.state.availableAccountsList || []}
            sweepTypes={this.state.sweepTypes}
            pageJson={this.state.sweepGroupsPageJson.par}
            lang={this.props.lang}
            readOnlyList />
          <button className="gdocs-btn-default"
            onClick={this.onSelectSweepInstructionsClick.bind(this, i)}
            disabled={this.shouldDisableSweepInstructionsSelection(i) || this.props.customer.roleDetails.customer}>
            {this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.selectSweepBtnText)}
          </button>
        </div>
      );
    }
    return (
      <div className="sweep-groups-and-limits-section">
        <div className="form-row">
          <div className="form-column">
            <label>{this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.defineGrp)}</label>
          </div>
          <div className="form-column">
            <label className="radio-label">
              {this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.no)}
              <Radiobutton setInputvalue={this.handleDefineSweepGroupsChange}
                name="sweepGroups"
                disabled={this.props.customer.roleDetails.customer}
                _value={this.state.defineSweepGroups}
                value="false" />
            </label>
            <label className="radio-label">
              {this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.yes)}
              <Radiobutton setInputvalue={this.handleDefineSweepGroupsChange}
                name="sweepGroups"
                disabled={this.props.customer.roleDetails.customer}
                _value={this.state.defineSweepGroups}
                value="true" />
            </label>
          </div>
        </div>
        {
          this.state.defineSweepGroups ? (
            <div className="sweep-group-limit-slot-section">
              {sweepGroupSlotsJsx}
              <button className="gdocs-btn-default" disabled={this.props.customer.roleDetails.customer} onClick={this.onSweepGroupAddition}><i className="icon icon-add"></i> {this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.addGrpBtn)}</button>
            </div>
          ) : ''
        }
      </div>
    );
  }

  shouldDisable = (item, sweepGroups) => {
    if (safeGet(item, "sweepParticipantsAccounts.sweepType.name").toLowerCase().startsWith("dynamic")) {
      // check in all groups if not there then send false
      return !sweepGroups.some(sg => {
        return sg.sweepInstructions.indexOf(item.id) !== -1;
      });
    }
    return false;
  }

  isSweepOrderRequired = (value) => {
    this.setState({
      isSweepOrderDefined: value
    });
  }

  shouldShowWarning = (sweepInstructions = [], sweepGroups = []) => {
    var showWarning = false;
    showWarning = sweepInstructions.some(si => {
      if (safeGet(si, "sweepParticipantsAccounts.sweepType.name").toLowerCase().startsWith("dynamic")) {
        return !sweepGroups.some(sg => {
          return sg.sweepInstructions.indexOf(si.id) !== -1;
        });
      } else {
        return false;
      }
    });
    return showWarning;
  }
  setSweepsAndSweepGroupsOrder = (orderOfExecution) => {
    this.setState({ orderOfExecution });
  }
  setSweepInstructionsDefaultOrdering = (orderOfExecution, sweepInstructions) => {

    sweepInstructions.forEach((si, index) => {

      if (orderOfExecution[index] === undefined || orderOfExecution[index].orderNumber === undefined) {
        orderOfExecution.forEach(ele => {
          if (ele.sweepId !== si.id) {
            orderOfExecution[index] = {
              orderNumber: (index + 1).toString(),
              sweepId: si.id,
              sweepGroupId: undefined
            }
          }
          else {
            orderOfExecution[index] = {
              orderNumber: index,
              sweepId: si.id
            }
          }
        });
        if (orderOfExecution.length === 0) {
          orderOfExecution[index] = {
            orderNumber: (index + 1).toString(),
            sweepId: si.id,
            sweepGroupId: undefined
          }
        }
      }
    });
    return orderOfExecution;
  }
  setSweepGroupsDefaultOrdering = (orderOfExecution, sweepGroups, sweepInstructionsLength) => {
    sweepGroups.forEach((sg, index) => {
      if (orderOfExecution[sweepInstructionsLength + index] === undefined || orderOfExecution[sweepInstructionsLength + index].orderNumber === undefined) {
        orderOfExecution[sweepInstructionsLength + index] = {
          orderNumber: (sweepInstructionsLength + index + 1).toString(),
          sweepId: undefined,
          sweepGroupId: sg.id
        }
      }
    });
    return orderOfExecution;
  }
  getDefaultSweepOrderingIfNoOrder = () => {
    var orderOfExecution = [...this.state.orderOfExecution];
    orderOfExecution = this.setSweepInstructionsDefaultOrdering([...orderOfExecution], this.state.sweepInstructions);
    orderOfExecution = this.setSweepGroupsDefaultOrdering([...orderOfExecution], this.state.sweepGroupsLimits, this.state.sweepInstructions.length);
    return orderOfExecution;
  }
  renderOrderOfSweepExecutionForm() {
    return (
      <div className="order-of-sweep-execution-section">
        <OrderableSweepList sweepInstructions={this.state.sweepInstructions || []}
          sweepGroups={this.state.sweepGroupsLimits || []}
          accounts={this.state.availableAccountsList || []}
          disabled={this.props.customer.roleDetails.customer}
          orderOfExecution={this.getDefaultSweepOrderingIfNoOrder() || []}
          setSweepsAndSweepGroupsOrder={this.setSweepsAndSweepGroupsOrder}
          shouldDisable={this.shouldDisable}
          lang={this.props.lang}
          isSweepOrderRequired={this.isSweepOrderRequired}
          isSweepOrderDefined={this.state.isSweepOrderDefined}
          showWarning={this.shouldShowWarning(this.state.sweepInstructions, this.state.sweepGroupsLimits)}
          editOrderBtnText={this.translations(this.state.sweepExecutionPageJson.par.staticText_orderOfSweepExecution.intraGrpBtn)}
          bannerText={this.translations(this.state.sweepExecutionPageJson.par.staticText_orderOfSweepExecution.notificationDynamic)}
          pageJSON={this.state.sweepExecutionPageJson.par} />
      </div>
    );
  }

  deleteSweepInstruction = (sweepInstruction) => {
    var { productId } = this.props.match.params;
    this.delteedSweepId = sweepInstruction.id;
    this.isSweepDeleted = true;
    eapiClient(`/product/gls/cashCon/${productId}/deleteSweep/${sweepInstruction.id}`, { method: 'DELETE' })
      .then(({ data }) => {
        this.loadCaptureProductGlsCashConPageState();
      })
      .then((dataKey) => {
        this.loadCashConTabStatus();
      })
  }

  toSweepInstructionCreatePage = (event) => {
    var { caseId, productId } = this.props.match.params;
    var sweepId = "";
    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify({ id: productId, cashConcentration: { sweepInstructions: [{}] } })
    })
      .then(({ data, status }) => {
        if (status === 200) {
          sweepId = data.responseData.cashConcentration.sweepInstructions.pop().id;
          this.props.history.push({
            pathname: `/case-body/capture-product-cashcon/sweep-instruction/${caseId}/${productId}/${sweepId}`,
            state: {
              isNavigate: this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate === true ? true : false,
            }
          });
        }
      });
  }

  toSweepInstructionEditPage = (sweepInstruction) => {
    var { caseId, productId } = this.props.match.params;

    if (sweepInstruction.id !== undefined) {
      this.props.history.push({
        pathname: `/case-body/capture-product-cashcon/sweep-instruction/${caseId}/${productId}/${sweepInstruction.id}`,
        state: {
          isNavigate: this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate === true ? true : false,
        }
      });
    }
  }

  loadCashConTabStatus = () => {
    var { productId } = this.props.match.params;
    let cashConTabStatus;
    if (this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate === true) {
      cashConTabStatus = `/product/gls/${productId}/cashConcentrationStatus`
    } else {
      cashConTabStatus = `/product/gls/${productId}/cashConcentrationStatus`
    }
    eapiClient(cashConTabStatus)
      .then(({ data }) => {
        this.props.setCurrentProductGlsCashConStatuses(data.responseData);
      });
  }

  // Basic Detai Payload
  onBasicDetailTabDataSubmit = (event, apiUrl) => {
    var { productId } = this.props.match.params;
    var payload = new basicDetailPayload();
    payload.setPayload(this.state);
    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.loadCashConTabStatus();
        this.loadCaptureProductGlsCashConPageState()
      });
  }

  // Account Interest Limit submit
  onAccountInterestLimitTabDataSubmit = () => {
    var { productId } = this.props.match.params;
    var payload = new accountInterestLimitPayload();
    var cashcon = this.state;
    var accountInterestLimits = cashcon.accountInterestLimits;
    if (accountInterestLimits !== undefined) {
      accountInterestLimits = accountInterestLimits.map(item => {
        if (item.lendingLimit === "N/A") {
          item.lendingLimitBreachAction = { name: "N/A", value: "na" }
        }
        if (item.borrowingLimit === "N/A") {
          item.borrowingLimitBreachAction = { name: "N/A", value: "na" }
        }
        return item;
      });
    }
    cashcon.accountInterestLimits = accountInterestLimits;
    payload.setPayload(cashcon, this.updateAccountLimitTiers);
    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.loadCashConTabStatus();
      });
  }

  updateAccountLimitTiers = (accountLimitData) => {
    const accountLimitObject = { ...accountLimitData }
    const formCondition = {
      accountInterestCreditTiers: "tiersCredit",
      accountInterestDebitTiers: "tiersDebit",
      odLimitTier: "tiersUnauthorizedOD"
    }
    Object.keys(formCondition).map(key => {
      if (accountLimitObject[key] && accountLimitObject[formCondition[key]]) {
        accountLimitObject[key] = this.updateTiers(accountLimitObject[key], accountLimitObject[formCondition[key]])
        delete accountLimitObject[formCondition[key]]
      }
    })
    return this.resetDataBasedOnTierStatus(accountLimitObject)
  }

  // Sweep group and Limits
  onSweepGroupLimitsTabDataSubmit = () => {
    var { productId } = this.props.match.params;
    var payload = new sweepGroupLimitPayload();
    payload.setPayload(this.state);

    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.loadCashConTabStatus();
      });
  }

  // Sweep Execution

  onSweepExecutionTabDataSubmit = () => {
    var { productId } = this.props.match.params;
    var payload = new sweepExecutionPayload();
    var sweepOrderDefined = this.state.isSweepOrderDefined
    // payload.setPayload(this.state);
    // eapiClient(`/product/gls/${productId}`, {
    //   method: 'PUT',
    //   data: JSON.stringify(payload.data)
    // })
    //   .then(({ data }) => {
    //     this.loadCashConTabStatus();
    //   });
    if (this.state.orderOfExecution !== undefined) {
      let order = [...this.state.orderOfExecution];
      let _unique = [];
      let sweepLists = [];
      let finalList = [];
      order.map(x => _unique.filter(a => a.sweepId === x.sweepId).length > 0 ? null : _unique.push(x));
      order.map(x => _unique.filter(a => a.sweepGroupId === x.sweepGroupId).length > 0 ? null : _unique.push(x));
      _unique.forEach(element => {
        if (element.intraGroupOrder) {
          element.intraGroupOrder.forEach(ele => {
            sweepLists.push({ sweepId: ele.sweepInstructionId })
          });
        }
      });
      // _unique.forEach((x) => { delete x.orderNumber });
      _unique.map(x => sweepLists.filter(a => a.sweepId === x.sweepId).length > 0 ? null : finalList.push(x));
      let orderList = finalList.map((item, i) => {
        return {
          // orderNumber: i + 1,
          ...item
        }
      })
      this.setState({
        orderOfExecution: orderList,
        isSweepOrderDefined: sweepOrderDefined
      }, () => {
        payload.setPayload(this.state);
        eapiClient(`/product/gls/${productId}`, {
          method: 'PUT',
          data: JSON.stringify(payload.data)
        })
          .then(({ data }) => {
            this.loadCashConTabStatus();
            this.loadCaptureProductGlsCashConPageState()
          });
      })
    }
  }
  // Save and Refresh Sumbit for Reporting Section
  onSubmitReportingSectionData = () => {
    var { productId } = this.props.match.params;
    var payload = new EchannelReportingSection();
    payload.setPayload(this.state);
    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.props.setCurrentProductGlsCashCon({ ...data.responseData });
        this.loadCashConTabStatus();
        this.loadCaptureProductGlsCashConPageState()
      });
  }

  // Main payload
  toNextpage = () => {
    var { productId } = this.props.match.params;
    var payload = new SaveAndReturn();
    if (this.state.orderOfExecution !== undefined) {
      let order = [...this.state.orderOfExecution];
      let _unique = [];
      let sweepLists = [];
      let finalList = [];
      order.map(x => _unique.filter(a => a.sweepId === x.sweepId).length > 0 ? null : _unique.push(x));
      order.map(x => _unique.filter(a => a.sweepGroupId === x.sweepGroupId).length > 0 ? null : _unique.push(x));
      _unique.forEach(element => {
        if (element.intraGroupOrder) {
          element.intraGroupOrder.forEach(ele => {
            sweepLists.push({ sweepId: ele.sweepInstructionId })
          });
        }
      });
      // _unique.forEach((x) => { delete x.orderNumber });
      _unique.map(x => sweepLists.filter(a => a.sweepId === x.sweepId).length > 0 ? null : finalList.push(x));
      let orderList = finalList.map((item, i) => {
        return {
          // orderNumber: i + 1,
          ...item
        }
      })
      this.setState({
        orderOfExecution: orderList
      }, () => {
        payload.setPayload(this.state, this.updateAccountLimitTiers);
        eapiClient(`/product/gls/${productId}`, {
          method: 'PUT',
          data: JSON.stringify(payload.data)
        })
          .then(({ data }) => {
            this.props.history.push('/case-body');
          });
      })
    }
  }

  handleNavListClick = (index) => {

  }

  updateSweepAfterDelete = () => {
    var { productId } = this.props.match.params;
    var sweepGroupsLimits = [...this.state.sweepGroupsLimits];
    let sweepInstructionsList = [];
    let instructionsList = [...this.state.sweepInstructions];
    let execOrder = [];
    let order = [];
    if (this.state.sweepGroupsLimits.length > 0) {
      sweepGroupsLimits.forEach((grp, index) => {
        sweepInstructionsList.push(grp.sweepInstructions);
      });
      let sweepArray = [].concat.apply([], sweepInstructionsList);
      let instructions = [];
      instructionsList.forEach(ele => {
        instructions.push(ele.id);
      });
      let orderList = instructions.filter(x => !sweepArray.includes(x));
      let orderExec = orderList.map((ele) => {
        return {
          sweepId: ele
        }
      })
      orderExec.forEach((x) => { delete x.orderNumber });
      let instructionGroup = [];
      sweepGroupsLimits.forEach((sgl, i) => {
        instructionGroup.push({
          sweepGroupId: sgl.id,
          intraGroupOrder: sgl.sweepInstructions.map(((item, index) => {
            return {
              sweepInstructionId: item,
              orderNumber: index + 1
            }
          }))
        });
      });
      execOrder = [...orderExec, ...instructionGroup];
      order = execOrder.map((obj, index) => ({ orderNumber: index + 1, ...obj }));
    }
    else {
      // order = this.state.orderOfExecution.map((obj, index) => ({ orderNumber: index + 1, ...obj }));
      order = instructionsList.map((obj, i) => {
        return {
          orderNumber: i + 1,
          sweepId: obj.id
        }
      });
    }
    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify({
        cashConcentration: {
          orderOfExecution: order,
          sweepGroupsLimits: sweepGroupsLimits
        }
      })
    })
      .then(({ data }) => {
        this.setState({
          orderOfExecution: data.responseData.cashConcentration.orderOfExecution,
          sweepGroupsLimits: data.responseData.cashConcentration.sweepGroupsLimits
        }, () => {
          this.loadCashConTabStatus();
        });
      });
  }
  // Render E-Channel Reporting Section
  renderReportingSection = () => {
    let reporting_Jsx = [];
    for (var i = 0; i < this.state.noOfReporting; i++) {
      reporting_Jsx.push(
        <div className="reporting-container">
          <div className="reporting-section">
            <label className="reporting-section_label">{this.translations(this.state.pageJson.par.aemform_echannelReporting.eChannel)}</label>
            <div className="reporting-section_div">
              <MultiLineSelect
                defaultValue={this.translations(this.state.pageJson.par.aemform_echannelReporting.pleaseSelect)}
                requiredFields={{
                  "row1": ["eChannelType", "country"],
                  "row2": ["profileOwner"],
                  "row3": ["eChannelId"]
                }}
                formatters={{
                  "row1": [null, (data, fieldValue) => data.newEchannel ? `${fieldValue} (New)` : `${fieldValue} (Existing)`, null],
                  "row2": [],
                  "row3": []
                }}
                data={this.state.eChannels && this.state.eChannels.filter(echannel => echannel.eChannelType.name === "HSBCnet") || []}
                value={this.state.reportedEChannelId !== undefined ? this.state.reportedEChannelId : ''}
                disabledOptions={this.reportingEchannelDisableList}
                multiAccount={true}
                _onChange={this.handleReportingChange.bind(this, i)}
                isDisable={this.props.customer.roleDetails.customer || this.state.eChannelReported}
              />
              <span className="icon icon-add addicon" disabled={this.state.eChannelReported}></span>
              <PersistLink
                className="mrg-left"
                to={'/case-body/create-new-product-echannel/isEchannelRestricted'}
                history={this.props.history}
                state={this.state}
                data={`eChannelReporting${i}`}
                isDisable={this.props.customer.roleDetails.customer || this.state.eChannelReported}
              >
                {this.translations(this.state.pageJson.par.aemform_echannelReporting.addEchannel)}
              </PersistLink>
            </div>
          </div>
        </div>
      )
    }
    return reporting_Jsx;
  }

  // E-channel Reporting handler
  handleReportingChange = (index, data) => {
    let eChannel = data.id;
    this.reportingEchannelDisableList.indexOf(data.id) === -1 && this.reportingEchannelDisableList.includes(data.id)
      ? this.reportingEchannelDisableList.push(data.id)
      : this.reportingEchannelDisableList

    this.reportingEchannelDisableList = data.id

    this.setState({
      reportedEChannelId: eChannel,
    })
  }

  // setShouldReportToEchannel = (value, name) => {
  //   if (value === true) {
  //     this.setState({
  //       eChannelReported: value
  //     });
  //   } else {
  //     this.setState({
  //       eChannelReported: value,
  //       reportedEChannelId: '',
  //       disabledeChannelReporting: []
  //     });
  //     this.reportingEchannelDisableList = []
  //   }
  // }

  updateTiers = (tiersData = [], ccrRateTiers = []) => {
    return tiersData.map((tier, tierIndex) => {
      tier = { ...tier, ...ccrRateTiers[tierIndex] }
      return tier
    })
  }

  // Render GLS Reporting Section
  // renderGLSReportingSection = () => {
  //   let reporting_Jsx = [];
  //   for (var i = 0; i < this.state.noOfReporting; i++) {
  //     reporting_Jsx.push(
  //       <div className="reporting-container">
  //         <div className="reporting-section">
  //           <label className="reporting-section_label">{this.translations(this.state.pageJson.par.aemform_echannelReporting.glsReporting || "GLS Reporitng")}</label>
  //           <div className="reporting-section_div">
  //             <MultiLineSelect
  //               defaultValue={this.translations(this.state.pageJson.par.aemform_echannelReporting.pleaseSelect)}
  //               requiredFields={{
  //                 "row1": ["eChannelType", "country"],
  //                 "row2": ["profileOwner"],
  //                 "row3": []
  //               }}
  //               formatters={{
  //                 "row1": [null, (data, fieldValue) => data.newEchannel ? `${fieldValue} (New)` : `${fieldValue} (Existing)`, null],
  //                 "row2": [],
  //                 "row3": []
  //               }}
  //               data={this.state.eChannels && this.state.eChannels.filter(echannel => echannel.eChannelType.name === "HSBCnet" &&
  //                 echannel.profileOwner.name === this.state.currentGlsCashCon.glsAgent.name) || []}
  //               value={this.state.reportedEChannelId !== undefined ? this.state.reportedEChannelId : ''}
  //               disabledOptions={this.reportingEchannelDisableList}
  //               multiAccount={true}
  //               _onChange={this.handleReportingChange.bind(this, i)}
  //               isDisable={this.props.customer.roleDetails.customer}
  //             />
  //             <span className="icon icon-add addicon"></span>
  //             <PersistLink
  //               className="mrg-left"
  //               to={'/case-body/create-new-product-echannel'}
  //               history={this.props.history}
  //               state={this.state}
  //               data={`eChannelReporting${i}`}
  //               isDisable={this.props.customer.roleDetails.customer}
  //             >
  //               {this.translations(this.state.pageJson.par.aemform_echannelReporting.addEchannel)}
  //             </PersistLink>
  //           </div>
  //         </div>
  //       </div>
  //     )
  //   }
  //   return reporting_Jsx;
  // }

  resetDataBasedOnTierStatus = (tierData = {}) => {
    const updatedTierData = { ...tierData }
    const resetCondition = {
      accountCreditTierStatus: {
        notiering: ["accountInterestCreditTiers", []],
        incremental: ["credit", { interestRateType: "baseRate", rate: "fixed" }],
        cumulative: ["credit", { interestRateType: "baseRate", rate: "fixed" }]
      },
      accountDebitTierStatus: {
        notiering: ["accountInterestDebitTiers", []],
        incremental: ['debit', { interestRateType: "baseRate", rate: "fixed" }],
        cumulative: ['debit', { interestRateType: "baseRate", rate: "fixed" }]
      },
      odLimitTierStatus: {
        notiering: 'odLimitTier',
        incremental: "unauthorizedOD",
        cumulative: "unauthorizedOD"
      }
    }

    Object.keys(resetCondition).map(key => {
      const resetObject = resetCondition[key]
      if (updatedTierData[key]) {
        if (resetObject[updatedTierData[key]]) {
          const [keyToUpdate, value] = resetObject[updatedTierData[key]]
          if (keyToUpdate) {
            updatedTierData[keyToUpdate] = value
          }
        }
      }
    })
    return updatedTierData
  }

  handleCopySweepFrom = async (e, toSweepId) => {
    const { target } = e || {}
    const { productId } = this.props.match.params;
    if (target.value) {
      const { data: fromSweepData } = await eapiClient(`/product/gls/${productId}/sweepInstruction/${target.value}`)
      if (fromSweepData && fromSweepData.responseData) {
        this.updateSweepdetails(fromSweepData.responseData, toSweepId)
      }
    }
  }

  updateSweepdetails = (sweepInstructionData, toSweepId) => {
    const { productId } = this.props.match.params;
    eapiClient(`/product/gls/${productId}`, {
      method: 'PUT',
      data: JSON.stringify({
        id: productId,
        cashConcentration: {
          sweepInstructions: [this.getFormattedCopySweepInstructionData({ ...sweepInstructionData }, toSweepId)],
        }
      })
    }).then(({ data }) => {
      if (data.responseData) {
        this.loadCaptureProductGlsCashConPageState()
      }
    })
  }

  getFormattedCopySweepInstructionData = (sweepInstructionData = {}, toSweepId) => {
    if (sweepInstructionData.ccrInfo) {
      sweepInstructionData.ccrInfo.ccrRefId = " "
      if (sweepInstructionData.ccrInfo.interestEarnTierStatus === "incremental" || sweepInstructionData.ccrInfo.interestEarnTierStatus === "cumulative") {
        Array.isArray(sweepInstructionData.ccrInfo.interestEarnTiers) && sweepInstructionData.ccrInfo.interestEarnTiers.length &&
          sweepInstructionData.ccrInfo.interestEarnTiers.forEach(tier => {
            if (!isEmptyObject(tier)) {
              delete tier.id
              delete tier.lastUpdatedOn
              delete tier.tierRefId

            }
          })
      }
      if (sweepInstructionData.ccrInfo.interestChargesTierStatus === "incremental" || sweepInstructionData.ccrInfo.interestChargesTierStatus === "cumulative") {
        Array.isArray(sweepInstructionData.ccrInfo.interestChargeTiers) && sweepInstructionData.ccrInfo.interestChargeTiers.length &&
          sweepInstructionData.ccrInfo.interestChargeTiers.forEach(tier => {
            if (!isEmptyObject(tier)) {
              delete tier.id
              delete tier.lastUpdatedOn
              delete tier.tierRefId

            }
          })
      }
    }
    if (sweepInstructionData.sweepParticipantsAccounts && sweepInstructionData.sweepParticipantsAccounts.subAccount) {
      sweepInstructionData.sweepParticipantsAccounts.subAccount = ''
      delete sweepInstructionData.accountInterestLimits
      return { ...sweepInstructionData, id: toSweepId, }
    }
    return {
      ...sweepInstructionData,
      id: toSweepId,
    }
  }

  _checkboxHandler = (event) => {
    if (event) {
      this.setState({
        eChannelReported: event.target.checked,
        [event.target.name]: event.target.checked,
      });
    }

  }

  render() {
    var eChannelReporting = this.state.pageJson ? this.state.pageJson.par.aemform_echannelReporting : '';
    document.title = (this.state.pageJson !== undefined && this.state.currentGlsCashCon.id)
      ? `${"Product Requests"} - ${"Review Product"} - ${this.translations(this.state.pageJson.par.page_title_mainTitle.pageHeading)} ${this.state.currentGlsCashCon.refrenceId} - ${'HSBC GLCM'}`
      : `${"Product Requests"}- ${'HSBC GLCM'}`;
    return (this.state.pageJson && eChannelReporting && this.props.currentProductGlsCashcon.statuses.sweepInstructions !== undefined &&
      this.props.currentProductGlsCashcon.data.cashConcentration !== undefined &&
      this.state.sweepAccountsPageJson && this.state.currentGlsCashCon.id &&
      this.state.sweepGroupsLimitsPageJson && this.state.sweepExecutionPageJson ? (
      <div className="product-gls-cashcon-container">
        <div className="pannel-heading-container">
          <h2 className="pannel-heading">{`${this.translations(this.state.pageJson.par.page_title_mainTitle.pageHeading)}`} <span className="ref">{`(${this.state.currentGlsCashCon.refrenceId})`}</span></h2>
          <p className="pannel-sub-heading">{`${this.translations(this.state.pageJson.par.page_title_mainTitle.agent)} : ${this.state.currentGlsCashCon.glsAgent.name}`}{this.state.currentGlsCashCon.cashConTitle !== undefined ? `(${this.state.currentGlsCashCon.cashConTitle})` : ''}</p>
          <p className="optional-text">{this.translations(this.state.pageJson.par.page_title_mainTitle.descriptionText)}</p>
        </div>
        <div className="gdocs-clear-float"></div>
        <NavListAccordionWrapper>
          <NavListAccordion
            lang={this.props.lang.currentLang.lang}
            navAccHeading={`1. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_cashcon.accordion1)}`}
            status={this.props.currentProductGlsCashcon.statuses.basicDetails.status}
            _onClick={this.handleNavListClick.bind(this, 0)}
          >
            <div className="basic-details-section">{this.renderBasicDetailsForm()}</div>
          </NavListAccordion>
          <NavListAccordion
            lang={this.props.lang.currentLang.lang}
            navAccHeading={`2. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_cashcon.accordion2)}`}
            status={this.props.currentProductGlsCashcon.statuses.sweepInstructions.status}
          >
            {this.state.sweepGroupsPageJson ? this.renderSweepInstructionsForm() : ''}
          </NavListAccordion>
          <NavListAccordion
            lang={this.props.lang.currentLang.lang}
            navAccHeading={`3. ${this.translations(eChannelReporting.eChannelRep)}`}
            status={(this.props.currentProductGlsCashcon.statuses !== undefined && this.props.currentProductGlsCashcon.statuses.echannelReporting !== undefined) ? this.props.currentProductGlsCashcon.statuses.echannelReporting.status : ''}
          >
            <div className="reporting">
              <p>
                {this.translations(eChannelReporting.eChannelHSBCnetInfoone)}<br />
                {this.translations(eChannelReporting.eChannelHSBCnetInfotwo)}
              </p>
              {this.renderReportingSection()}
              <div className={classNames("reporting-section", { "disabled": Boolean(this.state.reportedEChannelId) })}>
                <label className="reporting-section_label">
                  {this.translations(eChannelReporting.eChannelCheckBox)}
                </label>
                <div
                  className="reporting-section_div"
                  role="radiogroup"
                  aria-label={this.translations(eChannelReporting.eChannelCheckBox)}
                >
                  <Checkbox
                    name="setShouldReportToEchannel"
                    id="setShouldReportToEchannel"
                    checked={this.state.eChannelReported}
                    onChange={this._checkboxHandler}
                    disabled={Boolean(this.state.reportedEChannelId)}
                    controlled
                  />
                </div>
              </div>

              {/* {this.renderGLSReportingSection()} */}


              <div className="gdocs-clear-float"></div>
              <div key="buttons-wrapper" className="form-buttons-save-section">
                <div className="form-buttons-wrapper">
                  <button onClick={this.onSubmitReportingSectionData} className='gdocs-btn-submit'>{this.translations(eChannelReporting.saveAndRefresh)}</button>
                </div>
              </div>
              <div className="gdocs-clear-float"></div>
            </div>
          </NavListAccordion>

          {
            this.state.accountInterestLimits.length > 0 ?
              <NavListAccordion
                lang={this.props.lang.currentLang.lang}
                navAccHeading={`4. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_cashcon.accordion3)}`}
                status={this.props.currentProductGlsCashcon.statuses.accountInterestAndlimits.status}
              >
                <div className="account-interest-and-limits-section">
                  {this.renderAccountInterestAndLimitsForm()}
                  <div className="gdocs-clear-float"></div>
                  <div key="buttons-wrapper" className="form-buttons-save-section">
                    <div className="form-buttons-wrapper">
                      <button
                        id="refresh-btn"
                        className="gdocs-btn-submit"
                        onClick={this.onAccountInterestLimitTabDataSubmit}
                      >{this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.saveRefresh)}</button>
                    </div>
                  </div>
                </div>
              </NavListAccordion> : ''
          }
          <NavListAccordion
            lang={this.props.lang.currentLang.lang}
            navAccHeading={`${this.state.accountInterestLimits.length > 0 ? '5.' : '4.'} ${this.translations(this.state.pageJson.par.dynamic_accordion_list_cashcon.accordion4)}`}
            status={this.props.currentProductGlsCashcon.statuses.sweepGroupsAndlimits.status}
          >
            {this.state.sweepGroupsPageJson ? this.renderSweepGroupsAndLimits() : ''}
            <div className="gdocs-clear-float"></div>
            <div key="buttons-wrapper" className="form-buttons-save-section">
              <div className="form-buttons-wrapper">
                <button
                  className="gdocs-btn-submit"
                  onClick={this.onSweepGroupLimitsTabDataSubmit}
                >{this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.saveRefresh)}</button>
              </div>
            </div>
          </NavListAccordion>
          {this.props.currentProductGlsCashcon.data.cashConcentration.sweepInstructions.length > 0 ?
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`${this.state.accountInterestLimits.length > 0 ? '6.' : '5.'} ${this.translations(this.state.pageJson.par.dynamic_accordion_list_cashcon.accordion5)}`}
              status={this.props.currentProductGlsCashcon.statuses.orderOfSweepExecution.status}
            >
              {this.state.sweepGroupsPageJson ? this.renderOrderOfSweepExecutionForm() : ''}
              <div className="gdocs-clear-float"></div>
              <div key="buttons-wrapper" className="form-buttons-save-section">
                <div className="form-buttons-wrapper">
                  <button
                    className="gdocs-btn-submit"
                    onClick={this.onSweepExecutionTabDataSubmit}
                  >{this.translations(this.state.sweepExecutionPageJson.par.staticText_orderOfSweepExecution.saveRefresh)}</button>
                </div>
              </div>
            </NavListAccordion> : ''}
        </NavListAccordionWrapper>
        <div className="save-and-return">
          <button
            onClick={this.toNextpage}
            className='gdocs-btn-primary'
          >
            {this.translations(this.state.sweepAccountsPageJson.guideContainer.rootPanel.items.static_text_saveAndReturn.text)}
          </button>
        </div>
        <SweepSelectionsDialog
          redBtn="Set sweep selection"
          clearBtn="Clear selections"
          cancelBtn="Cancel"
          modalTitle={this.state.sweepGroupsLimitsPageJson ? this.translations(this.state.sweepGroupsLimitsPageJson.par.staticText_sweepGroupLimits.sweepselectionforgroup) : ''}
          showDialog={this.state.showSelectSweepInstructionsDialog}
          currentSelectedGroupIndex={this.state.currentSelectedGroupIndex}
          sweepTypes={this.state.sweepTypes}
          pageJson={this.state.sweepGroupsPageJson && this.state.sweepGroupsPageJson.par}
          lang={this.props.lang}
          sweepInstructions={this.getSweepInstructionForGroupFormation()}
          sweepGroup={this.state.sweepGroupsLimits[this.state.currentSelectedGroupIndex]}
          availableAccountsList={this.state.availableAccountsList}
          toggleDialog={this.toggleDialog}
          _onSetSelections={this._onSetSweepGroupSelections}
          _onCancel={this.toggleDialog}
          bsClass="gdocs-sweep-selections-dialog"
        />
      </div>)
      : '');
  }

  // DGT-6804 crashing issue
  // shouldComponentUpdate(nextProps) {
  //   return JSON.stringify(this.props) !== JSON.stringify(nextProps)
  // }
}

const mapStateToProps = state => {
  return {
    currentProductGlsCashcon: state.currentProductGlsCashcon,
    customer: state.auth.userDetails,
    entities: state.entities,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setCurrentProductGlsCashCon: productGlsCashConData => {
      dispatch(setCurrentProductGlsCashCon(productGlsCashConData));
    },
    setCurrentProductGlsCashConStatuses: statuses => {
      dispatch(setCurrentProductGlsCashConStatuses(statuses));
    },
    hideActionButton: () => {
      dispatch(hideActionButton());
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureProductGlsCashCon);


// Basic detail class
class basicDetailPayload {
  setPayload({ basicDetails }) {
    basicDetails.glsProductType = { name: 'Cash Concentration', value: "cashcon" };
    this.data = { ...basicDetails };
  }
}

// Account And Interest Limit class
class accountInterestLimitPayload {
  constructor(props) {
    this.data = {}
    this.data.cashConcentration = {}
  }
  setPayload({ accountInterestLimits = [] }, updateAccountLimitTiers) {
    this.data.cashConcentration.accountInterestLimits = accountInterestLimits.map(accLimit => updateAccountLimitTiers(accLimit));
  }
}

// Sweep group Limit class
class sweepGroupLimitPayload {
  constructor(props) {
    this.data = {}
    this.data.cashConcentration = {}
  }
  setPayload({ sweepGroupsLimits, defineSweepGroups }) {
    this.data.cashConcentration.sweepGroupsLimits = sweepGroupsLimits;
    this.data.cashConcentration.sweepGroups = defineSweepGroups;
  }
}
// E-Channel Reporting Section Payload
class EchannelReportingSection {
  constructor() {
    this.data = {}
    this.data.cashConcentration = {}
  }
  setPayload({ eChannelReported, reportedEChannelId }) {
    this.data.cashConcentration.eChannelReported = eChannelReported;
    this.data.cashConcentration.reportedEChannelId = reportedEChannelId;
  }
}

//sweep Execution class
class sweepExecutionPayload {
  constructor(props) {
    this.data = {}
    this.data.cashConcentration = {}
  }
  setPayload({ orderOfExecution, isSweepOrderDefined }) {
    this.data.cashConcentration.orderOfExecution = orderOfExecution;
    if (isSweepOrderDefined !== undefined) {
      this.data.cashConcentration.isSweepOrderDefined = isSweepOrderDefined;
    }
  }
}

// Main class
class SaveAndReturn {
  setPayload({ basicDetails, sweepInstructions, accountInterestLimits, defineSweepGroups, eChannelReported, reportedEChannelId, sweepGroupsLimits,
    orderOfExecution, isSweepOrderDefined }, updateAccountLimitTiers) {
    basicDetails.glsProductType = { name: 'Cash Concentration', value: "cashcon" };
    this.data = { ...basicDetails };
    this.data.cashConcentration.sweepInstructions = sweepInstructions;
    this.data.cashConcentration.accountInterestLimits = accountInterestLimits;
    this.data.cashConcentration.sweepGroups = defineSweepGroups;
    this.data.cashConcentration.sweepGroupsLimits = sweepGroupsLimits;
    this.data.cashConcentration.orderOfExecution = orderOfExecution;
    this.data.cashConcentration.eChannelReported = eChannelReported;
    this.data.cashConcentration.reportedEChannelId = reportedEChannelId
    if (isSweepOrderDefined !== undefined) {
      this.data.cashConcentration.isSweepOrderDefined = isSweepOrderDefined;
    }
    if (orderOfExecution === undefined || orderOfExecution === null || orderOfExecution.length === 0) {
      delete this.data.cashConcentration.isSweepOrderDefined;
    }
    if (this.data.cashConcentration.accountInterestLimits) {
      this.data.cashConcentration.accountInterestLimits = this.data.cashConcentration.accountInterestLimits.map(accountLimit => (
        updateAccountLimitTiers(accountLimit)
      ))
    }
  }
}

class SweepGroup {
  constructor({ id, lid }) {
    this.id = id;
    this.lid = lid;
    this.sweepGroupId = 'GRP';
    this.icsLimit = false;
    this.sweepInstructions = [];
    this.limitType = 'Group Facility Limit'
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsCashCon/index.js